import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import PromoNavigation from '../../containers/promo-navigation';

import PromoNavigationContainer from '../../blocks/promo-navigation-container';
import Html from '../../containers/html';
import Wysiwyg from '../../containers/wysiwyg';

const PromoNavigationBlock = props => <PromoNavigation {...props} />;
PromoNavigationBlock.displayName = 'PromoNavigation';

export default withDynamicComponents({
  componentWhitelist: [
    PromoNavigationContainer,
    Html,
    Wysiwyg,
  ],
  mapInputToOutput: [
    ['components', 'children'],
  ],
})(PromoNavigationBlock);



// WEBPACK FOOTER //
// ./src/blocks/promo-navigation/index.jsx